const ID = 'header';

export default ID;
